module.exports = {"meteorProgramsFolder":"/usr/app/build/meteor/bundle/programs","injectMeteorRuntimeConfig":false,"exclude":["autoupdate","global-imports","hot-code-push","reload","ecmascript"]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/meteor-imports-webpack-plugin/meteor-config.json
 ** module id = ./node_modules/meteor-imports-webpack-plugin/meteor-config.json
 ** module chunks = 0 1
 **/